export default function MemoryDotPrivacyPolicy() {
  return (
    <div className="App">
      <h3>Privacy Policy - Memory Dot Puzzle</h3>
      
      <div style={{ textAlign: 'left', maxWidth: '800px', margin: '0 auto', padding: '20px' }}>
        <p><strong>Last Updated: January 2025</strong></p>
        
        <p>This privacy policy applies to the Memory Dot Puzzle app (hereby referred to as "Application") for mobile devices that was created by Neeraj Kumar (hereby referred to as "Service Provider") as a Freemium service.</p>

        <h4>Our Privacy Promise</h4>
        <div style={{ backgroundColor: '#e8f4fd', padding: '15px', borderRadius: '5px', margin: '20px 0' }}>
          <p><strong>We don't collect ANY personal data.</strong></p>
          <p>Memory Dot Puzzle is designed with privacy at its core. Your brain training journey is completely private and stays on your device.</p>
        </div>

        <h4>Information We Don't Collect</h4>
        <p>Unlike many apps, we do NOT collect, store, or transmit:</p>
        <ul>
          <li>Personal identification information (name, email, phone number)</li>
          <li>Location data</li>
          <li>Device identifiers (except as required by app stores for purchases)</li>
          <li>Usage analytics or behavioral data</li>
          <li>Game performance statistics to our servers</li>
          <li>Social media information</li>
          <li>Contacts or photos</li>
          <li>Any other personal data</li>
        </ul>

        <h4>Local Data Storage</h4>
        <p>All your data is stored locally on your device only:</p>
        <ul>
          <li><strong>Game Progress:</strong> Your scores, streaks, and completed challenges</li>
          <li><strong>Statistics:</strong> Performance metrics and analytics</li>
          <li><strong>Settings:</strong> App preferences, theme choices, and difficulty settings</li>
          <li><strong>Premium Status:</strong> Whether you've purchased premium features</li>
        </ul>
        <p>This data never leaves your device and is not accessible to us or any third parties.</p>

        <h4>In-App Purchases</h4>
        <p>Premium features (₹349 lifetime) are available through in-app purchases processed by:</p>
        <ul>
          <li><strong>iOS:</strong> Apple App Store (Apple's Privacy Policy applies)</li>
          <li><strong>Android:</strong> Google Play Store (Google's Privacy Policy applies)</li>
        </ul>
        <p>We do not process or store payment information. All transactions are handled securely by Apple or Google. We only receive a confirmation that a purchase was made to unlock premium features on your device.</p>

        <h4>Permissions</h4>
        <p>Our app requests minimal permissions:</p>
        <ul>
          <li><strong>Vibration (Optional):</strong> For haptic feedback during gameplay</li>
          <li><strong>Local Notifications (Optional):</strong> For daily challenge reminders</li>
        </ul>
        <p>These permissions are only used for their stated purposes and do not enable any data collection.</p>

        <h4>Internet Connection</h4>
        <p>Memory Dot Puzzle works completely offline. An internet connection is only required for:</p>
        <ul>
          <li>Downloading the app from app stores</li>
          <li>Processing in-app purchases</li>
          <li>Restoring previous purchases on new devices</li>
        </ul>
        <p>No gameplay data, statistics, or usage information is transmitted over the internet.</p>

        <h4>Data Backup</h4>
        <p>Your local data may be included in your device's automatic backup systems:</p>
        <ul>
          <li><strong>iOS:</strong> iCloud backups (controlled by your iOS settings)</li>
          <li><strong>Android:</strong> Google Drive backups (controlled by your Android settings)</li>
        </ul>
        <p>These backups are managed by Apple or Google according to their privacy policies. We do not have access to these backups.</p>

        <h4>Children's Privacy</h4>
        <p>Memory Dot Puzzle is suitable for all ages, including children. Because we don't collect any personal data, we fully comply with children's privacy regulations including COPPA (Children's Online Privacy Protection Act) and similar laws worldwide.</p>
        <p>The Service Provider does not knowingly collect personally identifiable information from children. If you have reason to believe that a child has provided personally identifiable information to the Service Provider through the Application, please contact us at sainineeraj1234@gmail.com so that we will be able to take the necessary actions.</p>

        <h4>Data Security</h4>
        <p>While we don't collect personal data, we implement security best practices:</p>
        <ul>
          <li>All data is stored locally using secure device storage</li>
          <li>Premium purchase verification uses encrypted communications</li>
          <li>No data transmission to external servers</li>
          <li>Regular security updates to the app</li>
        </ul>

        <h4>Third-Party Services</h4>
        <p>Memory Dot Puzzle does not integrate with any third-party analytics, advertising, or tracking services. We have no partnerships with data brokers or advertising networks.</p>
        <p>The only third-party services involved are the app stores themselves (Apple App Store and Google Play Store) for distribution and in-app purchase processing.</p>

        <h4>Your Rights</h4>
        <p>Since we don't collect personal data, traditional data rights (access, deletion, portability) don't apply in the usual sense. However:</p>
        <ul>
          <li><strong>Data Control:</strong> All your data is on your device. You have complete control over it.</li>
          <li><strong>Data Deletion:</strong> Delete the app or clear app data in device settings to remove all information.</li>
          <li><strong>Data Portability:</strong> Your data is already on your device; no export needed.</li>
          <li><strong>Purchase History:</strong> Managed through your Apple or Google account.</li>
        </ul>

        <h4>International Users</h4>
        <p>Memory Dot Puzzle can be used worldwide. Since all data is stored locally on your device and we don't collect personal information, there are no international data transfer concerns. The app complies with privacy regulations including GDPR, CCPA, COPPA, and other regional privacy laws.</p>

        <h4>Changes to This Policy</h4>
        <p>The Service Provider may periodically update this Privacy Policy. You are advised to review this page regularly for any changes. The Service Provider will notify you of any changes by posting the new Privacy Policy on this page.</p>
        <p>This privacy policy is effective as of 2025-01-01</p>

        <h4>Your Consent</h4>
        <p>By using the Application, you are consenting to the processing of your information as set forth in this Privacy Policy now and as amended by us.</p>

        <div style={{ backgroundColor: '#f0f9ff', padding: '15px', borderRadius: '5px', margin: '20px 0' }}>
          <h5>Summary - In Plain English:</h5>
          <ul>
            <li>✅ We don't collect your personal data</li>
            <li>✅ Everything stays on your device</li>
            <li>✅ No tracking, no analytics</li>
            <li>✅ No accounts or registration required</li>
            <li>✅ Full offline functionality</li>
            <li>✅ Your brain training is completely private</li>
          </ul>
        </div>

        <h4>Contact Us</h4>
        <p>If you have any questions regarding privacy while using the Application, or have questions about the practices, please contact the Service Provider via email at <strong>sainineeraj1234@gmail.com</strong></p>
      </div>
    </div>
  );
}
